/**
 * Filters out x-hookdeck headers.
 *
 * @param headers - header map
 * @returns filtered header map
 */
export default function filteredHeaders(headers: Record<string, string>): Record<string, string> {
  const newHeaders: Record<string, string> = {};

  if (!headers) return newHeaders;

  Object.entries(headers).forEach(([header, value]) => {
    if (!header.startsWith('x-hookdeck')) {
      newHeaders[header] = value;
    }
  });
  return newHeaders;
}
